<section class="auth-page-statement">
  <div class="statement-content">
    <h1 class="statement-title">Welcome to Your Planful Marketing Account</h1>
    <p class="statement-text">Plannuh was acquired on September 15th 2022 by Planful, the pioneer of financial performance management cloud software.</p>
    <p class="statement-text">Nothing has changed within your account, your data is untouched and safe, so go ahead log in and find all the operational marketing excellence features the world has grown to love.</p>
    <p class="statement-text">The Planful platform is used around the globe to streamline business-wide planning, budgeting, consolidations, reporting, and analytics. Learn more at <a href="https://planful.com/" target="_blank">www.planful.com</a>.</p>
  </div>
</section>
